import { hasStyleOption } from './clean-department-utils'

export function cleanEntityStyles (entity, department) {
  if (!entity.hasOwnProperty('styles')) return

  entity.styles.defaults = entity.styles.defaults
    .filter(next => hasStyleOption(next.styleId, next.optionId, department))

  entity.styles.disabled = entity.styles.disabled
    .filter(next => hasStyleOption(next.styleId, next.optionId, department))
}
